import React, { useState } from 'react';
import ReactSelect, { components } from 'react-select';
import {
  Container,
  Label,
  LabelContainer,
  SingleValueText,
  TooltipContainer,
  TooltipText,
  selectStyles,
  ErrorContainer,
  MenuButton,
} from './Select.styles';
import { ReactComponent as InfoIcon } from '../../../assets/icons/info.svg';

const { Option, SingleValue, NoOptionsMessage } = components;

const Select = ({
  label,
  selectedOption,
  options,
  handleChange,
  isSearchable,
  placeholder,
  error,
  multiSelection,
  disabled,
  className,
  isClearable,
  hideError,
  tooltipText,
  menuButtonTitle,
  onMenuButtonClick,
  stylesOverride,
  menuPlacement,
}) => {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <Container>
      {label && (
        <LabelContainer>
          <Label>{label}</Label>
          {tooltipText && (
            <InfoIcon
              width={16}
              height={16}
              onMouseEnter={() => setShowTooltip(true)}
              onMouseLeave={() => setShowTooltip(false)}
            />
          )}
          {tooltipText && showTooltip && (
            <TooltipContainer>
              <TooltipText>{tooltipText}</TooltipText>
            </TooltipContainer>
          )}
        </LabelContainer>
      )}
      <ReactSelect
        styles={{ ...selectStyles, ...stylesOverride }}
        className={className}
        options={options}
        value={selectedOption}
        onChange={handleChange}
        closeMenuOnSelect={!multiSelection}
        menuPlacement={menuPlacement || 'auto'}
        isMulti={multiSelection}
        isDisabled={disabled}
        isSearchable={isSearchable}
        isClearable={isClearable}
        placeholder={placeholder}
        placeholderTextColor="#fff"
        components={{
          Option: props => IconOption(props),
          SingleValue: props => IconSingleValue(props),
          NoOptionsMessage: props => NoOptionsMessageComponent(props),
          ...(menuButtonTitle && { MenuList: props => SelectMenuButton(props, menuButtonTitle, onMenuButtonClick) }),
        }}
      />
      {!hideError && <ErrorContainer>{error}</ErrorContainer>}
    </Container>
  );
};

const SelectMenuButton = (props, buttonTitle, onMenuButtonClick) => {
  return (
    <components.MenuList {...props}>
      {props.children}
      <MenuButton onClick={onMenuButtonClick}>{buttonTitle}</MenuButton>
    </components.MenuList>
  );
};

const IconOption = props => {
  return (
    <Option {...props}>
      {props.data.icon}
      <SingleValueText>{props.data.label}</SingleValueText>
    </Option>
  );
};

const IconSingleValue = props => {
  return (
    <SingleValue {...props}>
      {props.data.icon}
      <SingleValueText>{props.data.label}</SingleValueText>
    </SingleValue>
  );
};

const NoOptionsMessageComponent = props => {
  return (
    <NoOptionsMessage {...props}>
      <SingleValueText>{props.children}</SingleValueText>
    </NoOptionsMessage>
  );
};

export default Select;
